import React from 'react';
import PropTypes from 'prop-types';

const TextareaQuestion = ({ question, value, onChange, error }) => {
  return (
    <textarea
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      className={`form-control form-control-sm${error ? ' is-invalid' : ''}`}
      rows="4"
    />
  );
};

TextareaQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string
};

export default TextareaQuestion;